import { SettingLandingBannersJobsInformationContainer } from "..";

export const SettingLandingBannersJobsMainContainer = () => {
  return (
    <div className="productDetailMainContainer">
      <SettingLandingBannersJobsInformationContainer />
    </div>
  );
};
